import {
  deleteRequestTracker,
  getRequestTracker,
  postRequestTracker,
  putRequestTracker
} from "../dataProvider";

export default class TrackerUtilService {
  async get(api, config) {
    let response = await getRequestTracker(api, config);
    return response;
  }

  async delete(api, config) {
    let response = await deleteRequestTracker(api, config);
    return response;
  }

  async post(api, data, config) {
    let response = await postRequestTracker(api, data, config);
    return response;
  }

  async put(api, data, config) {
    let response = await putRequestTracker(api, data, config);
    return response;
  }
}
